<template>
  <div v-if="inline || visible" class="app-modal-overlay"
    :class="{ 'app-modal-overlay--bottom-sheet': bottomSheet, 'app-modal-overlay--inline': inline }"
    @click.self="handleOverlayClick">
    <div class="app-modal"
      :class="[modalClass, { 'app-modal--bottom-sheet': bottomSheet, 'app-modal--inline': inline }]"
      :style="modalStyle">
      <div class="app-modal-header" v-if="$slots.header || title || showCloseButton">
        <slot name="header">
          <h3 class="app-modal-title">{{ title }}</h3>
        </slot>
        <button v-if="showCloseButton" type="button" class="app-modal-close" @click="close">
          <span>&times;</span>
        </button>
      </div>
      <div class="app-modal-body" :style="maxHeight ? { overflowY: 'auto', flex: 1, minHeight: 0 } : {}">
        <slot></slot>
      </div>
      <div class="app-modal-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "75%"
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    closeOnOverlay: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: String,
      default: ""
    },
    bottomSheet: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this._modalHistoryState = null;
    this._popstateHandler = null;
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    handleOverlayClick() {
      if (this.closeOnOverlay) {
        this.close();
      }
    }
  },
  computed: {
    modalStyle() {
      const style = {
        width: this.width,
        maxWidth: this.width
      };
      if (this.maxHeight) {
        style.maxHeight = this.maxHeight;
        style.display = 'flex';
        style.flexDirection = 'column';
      }
      return style;
    },
    modalClass() {
      return [];
    }
  },
  watch: {
    visible(val) {
      if (val) {
        document.body.style.overflow = "hidden";
        // Modal açıkken geri tuşuna basılırsa önce modal kapanır (web & mobil uyumlu)
        this._modalHistoryState = { appModal: true, id: Date.now() };
        history.pushState(this._modalHistoryState, "");
      } else {
        document.body.style.overflow = "";
        // Modal kapandıysa ve history state hâlâ bizimse geri al
        if (this._modalHistoryState && history.state && history.state.appModal && history.state.id === this._modalHistoryState.id) {
          history.back();
        }
        this._modalHistoryState = null;
      }
    }
  },
  mounted() {
    this._popstateHandler = (e) => {
      if (this.visible && this._modalHistoryState) {
        this._modalHistoryState = null;
        this.close();
      }
    };
    window.addEventListener("popstate", this._popstateHandler);
  },
  beforeDestroy() {
    document.body.style.overflow = "";
    if (this._popstateHandler) {
      window.removeEventListener("popstate", this._popstateHandler);
    }
    // Eğer modal açıkken component destroy olursa, history state'i temizle
    if (this._modalHistoryState && history.state && history.state.appModal && history.state.id === this._modalHistoryState.id) {
      history.back();
    }
    this._modalHistoryState = null;
  }
};
</script>

<style scoped>
.app-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow-y: auto;
  padding: 20px;
}

.app-modal-overlay--inline {
  position: static;
  display: block;
  padding: 0;
  background: transparent;
  overflow: visible;
}

/* .app-modal {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: relative;
} */
.app-modal {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, .15);
  position: relative;

  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.app-modal--inline {
  width: 100% !important;
  max-width: none !important;
  max-height: none;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
}

.app-modal--inline .app-modal-body {
  padding: 0;
}

.app-modal-body {
  padding: 20px;
}

.app-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e5e5;
  background: #f8f8f8;
  border-radius: 16px 16px 0 0;
}

.app-modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.app-modal-close {
  background: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  color: #666;
  transition: color 0.2s;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  -webkit-tap-highlight-color: transparent;
}

.app-modal-close:hover {
  color: #000;
}

.app-modal-close:active {
  background: rgba(0, 0, 0, 0.05);
}

.app-modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Mobil: tüm modaller full-width */
@media (max-width: 768px) {
  .app-modal {
    width: 100% !important;
    max-width: 100% !important;
  }

  .app-modal-body {
    padding: 16px;
  }
}

/* Bottom sheet: isteğe bağlı, sadece mobilde aktif */
@media (max-width: 768px) {
  .app-modal-overlay--bottom-sheet {
    padding: 0;
    align-items: flex-end;
  }

  .app-modal--bottom-sheet {
    max-height: 90vh !important;
    border-radius: 16px 16px 0 0;
    display: flex;
    flex-direction: column;
  }

  .app-modal--bottom-sheet .app-modal-body {
    overflow-y: auto;
    flex: 1;
    min-height: 0;
  }

  .app-modal-footer {
    padding: 16px;
  }
}
</style>
